// extracted by mini-css-extract-plugin
module.exports = {"btn":"BackToTopArrow-styles_btn__1Cyyf","active":"BackToTopArrow-styles_active__2v77c"};